module.exports = __webpack_public_path__ + "web-assets/img/map_placeholder.c7090e34.jpg";